/* eslint-disable eqeqeq */
import { Sticky, StickyContainer } from "react-sticky";
import { BasePage } from "../../../../framework/pages/BasePage";
import { Tabs } from "antd";
import ConfigurarPuntosSection from "../../tabs/ConfigurarPuntosSection";
import ProcedenciaMuestraModal from "../../tabs/ProcedenciaMuestraModal";
import EquiposUtilizadosModal from "../../tabs/EquiposUtilizadosModal";
import OtrosDatosModal from "../../tabs/OtrosDatosModal";
import DatosServisiosModal from "../../tabs/DatosServisiosModal";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { DATE_FORMAT, PAGE_MODE } from "../../../../constants/constants";
import { AgregarEstacionModal } from "../../../servicios-ejecutados/tabs/PlanificacionSejecutados/modals/AgregarEstacionModal";
import { EditarEstacionModal } from "../../../servicios-ejecutados/tabs/PlanificacionSejecutados/modals/EditarEstacionModal";
import { MessageUtil } from "../../../../util/MessageUtil";
import { LoadUtil } from "../../../../framework/util/LoadUtil";
import { RequestUtil } from "../../../../util/RequestUtil";
import { EnvConstants } from "../../../../EnvConstants";
import { DetalleMuestreoModal } from "../../tabs/DetalleMuestreoModal";
import { ModalContext } from "../../../../provider/ModalProvider";
import { COLUMN_DEFAULT } from "../../../../framework/grid/GridFw";
import { ParametrosCadenaModal } from "../../modals/ParametrosCadenaModal";

class CadenaSueloPage extends BasePage {
  static contextType = ModalContext;

  constructor(props) {
    super(props);
    this.state = {
      id_doc: null,
      keyPanel: "1",
    };
    this.cambiarTabPanel = this.cambiarTabPanel.bind(this);
  }

  cambiarTabPanel(tab, id_doc) {
    this.setState({
      id_doc: id_doc,
      keyPanel: tab,
      keyPrincipal: tab,
    });
  }

  renderPage(pageApi, keyPanel) {
    const getgrid_detalle_muestreo = () =>
      pageApi.getComponent("gridDetalleMuestreo");
    const { TabPane } = Tabs;

    const fnUpdateItem = (data) => {
      this.context.hideModal();
      getgrid_detalle_muestreo().saveItemEditing();
      const arrMuestreo = getgrid_detalle_muestreo().getData();

      setTimeout(() => {
        arrMuestreo.forEach((el) => {
          if (data.key == el.key) {
            getgrid_detalle_muestreo().updateItem({
              ...el,
              id_estacion: data.id_estacion,
              estaciondes: data.estaciondes,
              descripcion: data.descripcion,
              COORDF: data.COORDF,
              COORDN: data.COORDN,
            });
          } else {
            getgrid_detalle_muestreo().updateItem(el);
          }
        });
      }, 0);
    };

    const ConfiguracionModalConfig = (data) => {
      const { showModal } = this.context;
      let obj = {
        id_muestreo: data.id_muestreo,
      };

      showModal({
        width: 800,
        maskClosable: false,
        component: (
          <ParametrosCadenaModal name={obj} getParentApi={pageApi.getApi} />
        ),
      });
    };

    const ConfigEstacionModal = (data, esNuevo = true, id_estacion = 0) => {
      const { showModal } = this.context;
      let obj = {};

      obj = {
        fnUpdateItem,
        data: {
          ...data,
          id_tipo_matriz:
            getgrid_detalle_muestreo()?.itemEditing?.id_tipo_matriz,
          id_empresa: getgrid_detalle_muestreo()?.itemEditing.id_empresa,
          id_estacion: id_estacion,
        },
      };

      showModal({
        title: esNuevo ? "Agregar Estación" : "Editar Estación",
        width: 350,
        maskClosable: true,
        closable: false,
        background: "white",
        component: esNuevo ? (
          <AgregarEstacionModal name={obj} getParentApi={pageApi.getApi} />
        ) : (
          <EditarEstacionModal name={obj} getParentApi={pageApi.getApi} />
        ),
      });
    };

    const gridDetalleMuestreo = (pageApi) => ({
      layout: "vertical",
      title: "Estaciones",
      showIndex: true,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      rowId: "id_muestreo",
      load: {
        search: true,
        queryId: 920,
        params: () => {
          return {
            ID_CADENA: pageApi.getParamId(),
          };
        },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 895,
        hideMessage: true,
        hideMessageError: true,
        fnOk: (resp) => {   
            if (resp?.dataObject == 1) {
            MessageUtil("error", resp.message, "");
            }
            else { 
            MessageUtil("success", resp.message, ""); 
            } 
        },    
      },
      fields: [
        { name: "muestra", label: "Cod. Muestra" },
        { name: "matriz", label: "Matriz" },
        {
          type: "select",
          name: "id_estacion",
          labelName: "estaciondes",
          label: "Estación",
          column: 3,
          load: {
            queryId: 846,
            params: () => {
              return {
                id_empresa: getgrid_detalle_muestreo()?.itemEditing?.id_empresa,
                id_tipo_matriz:
                  getgrid_detalle_muestreo()?.itemEditing?.id_tipo_matriz,
              };
            },
          },
          search: true,
          editable: true,
          onChange: async (value, values, formApi) => {
            if (value == 0) {
              ConfigEstacionModal(formApi.getData(), true);
              formApi.setFieldData("id_estacion", null);
              formApi.setFieldData("descripcion", null);
              formApi.setFieldData("COORDF", null);
              formApi.setFieldData("COORDN", null);
            } else if (value == -1) {
              const id_estacion =
                getgrid_detalle_muestreo()?.itemEditing.id_estacion;
              const estaciondes =
                getgrid_detalle_muestreo()?.itemEditing.estaciondes;

              if (!id_estacion) {
                formApi.setFieldData("id_estacion", null);
                formApi.setFieldData("estaciondes", null);
                formApi.setFieldData("descripcion", null);
                formApi.setFieldData("COORDF", null);
                formApi.setFieldData("COORDN", null);
                return MessageUtil(
                  "warning",
                  "Advertencia",
                  "Debe seleccionar primero una estaciòn para poder editar.",
                );
              }

              fnUpdateItem({ ...formApi.getData(), id_estacion, estaciondes });
              ConfigEstacionModal(
                { ...formApi.getData(), id_estacion, estaciondes },
                false,
                id_estacion,
              );
              formApi.setFieldData("id_estacion", id_estacion);
              formApi.setFieldData("estaciondes", estaciondes);
            } else {
              const id_estacion = value;
              let label = formApi
                ?.getFieldApi("id_estacion")
                ?.getSelectedItem()?.label;
              let descripcion = formApi
                ?.getFieldApi("id_estacion")
                ?.getSelectedItem()?.descripcion;

              const reqParams = LoadUtil.getReqParams({
                queryId: 138,
                params: {
                  ID_ESTACION: id_estacion,
                },
              });

              const data = await RequestUtil.postData(
                EnvConstants.GET_URL_READ(),
                reqParams,
              )
                .then((resp) => resp.dataObject)
                .catch(() => []);

              formApi.setFieldData("COORDF", data?.COORDF);
              formApi.setFieldData("COORDN", data?.COORDN);
              formApi.setFieldData("id_estacion", value);
              formApi.setFieldData(
                "estacionDes",
                label || formApi.values.label,
              );
              formApi.setFieldData(
                "descripcion",
                descripcion || formApi.values.descripcion,
              );

              if (formApi.values.id_estacion !== value) {
                fnUpdateItem({
                  ...formApi.getData(),
                  id_estacion,
                  estaciondes: label,
                  descripcion,
                  COORDF: data?.COORDF,
                  COORDN: data?.COORDN,
                });
              }
            }
          },
        },
        {
          name: "descripcion",
          label: "Descripción",
          readOnly: true,
          editable: true,
        },
        {
          name: "fecha_prevista_muestreo",
          label: "Fecha Muestreo",
          editable: true,
          type: "date",
          format: "DD/MM/YYYY",
          inputFormat: DATE_FORMAT.YYYYMMDD,
        },
        {
          name: "hora_inicio_muestreo",
          label: "Hora Inicio",
          editable: true,
          type: "date",
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm,
        },
        {
          name: "fecha_recoleccion",
          label: "Fecha Recolección",
          editable: true,
          type: "date",
          format: "DD/MM/YYYY",
          inputFormat: DATE_FORMAT.YYYYMMDD,
        },
        {
          name: "hora_recoleccion",
          label: "Hora Recolección",
          editable: true,
          type: "date",
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm,
        },
        {
          name: "georeferencia",
          label: "Georeferencia",
          readOnly: true,
          editable: true,
        },
        {
          type: "select",
          name: "id_tipo_envase",
          labelName: "tipo_envase",
          label: "Tipo Envase",
          column: 3,
          load: {
            queryId: 948,
          },
          search: true,
          editable: true,
        },
        { name: "cant_envases", label: "Cant. Envases", editable: true },
        { name: "profundidad", label: "Profundidad", editable: true },
        { name: "observacion", label: "Observaciones Campo", editable: true },
        {
          ...COLUMN_DEFAULT.EXPERIMENT,
          title: "Ver Análisis",
          label: "Opciones",
          onClick: (value, row, index) => {
            ConfiguracionModalConfig(row);
          },
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const renderTabBar = (props, DefaultTabBar) => (
      <Sticky bottomOffset={80}>
        {({ style }) => (
          <DefaultTabBar
            {...props}
            className="site-custom-tab-bar"
            style={style}
          />
        )}
      </Sticky>
    );

    const gridsConfigDetalleMuestreo = [
      {
        name: "gridDetalleMuestreo",
        config: gridDetalleMuestreo(pageApi),
        type: "grid",
      },
    ];

    return (
      <StickyContainer>
        <Tabs
          destroyInactiveTabPane={true}
          activeKey={this.state.keyPanel}
          renderTabBar={renderTabBar}
          onChange={(key) => this.setState({ keyPanel: key })}
        >
          <TabPane tab="Configurar Puntos" key="1">
            <ConfigurarPuntosSection
              api={pageApi}
              name={{...pageApi.name}}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Datos del Servicio"
            key="2"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <DatosServisiosModal
              api={pageApi}
              name={{...pageApi.name}}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Procedencia de la muestra"
            key="3"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <ProcedenciaMuestraModal
              api={pageApi}
              name={{...pageApi.name}}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Detalle del muestreo"
            key="4"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <DetalleMuestreoModal
              api={pageApi}
              data={{ ...pageApi.name }}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
              gridsConfig={gridsConfigDetalleMuestreo}
            />
          </TabPane>

          <TabPane
            tab="Equipos Utilizados"
            key="5"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <EquiposUtilizadosModal
              api={pageApi}
              name={{...pageApi.name}}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Otros Datos"
            key="6"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <OtrosDatosModal
              api={pageApi}
              name={{...pageApi.name}}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>
        </Tabs>
      </StickyContainer>
    );
  }
}

export default withRouter(CadenaSueloPage);
